module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0070.png.7471d769.jpg";